import React, { useRef, useCallback, useContext, } from "react";
import { Form, RadioGroup, RequiredValidator, Datepicker, Card, CountrySelect, Button, } from "@lysaab/ui-2";
import { PepContext, PepStatus, EntityType, PepType } from "../PepContext";
import { useIntl, FormattedMessage } from "react-intl";
import { isOngoingMessages, endedMessages, isLocalCountryMessages, countrySelectionMessages, localCountryAltMessages, stateAltMessages, } from "./StatusMessages";
import { formatPossessive } from "../../utils/Possession";
export const StatusPage = ({ countryName, countryCode, language, next, }) => {
    const pepContext = useContext(PepContext);
    const formRef = useRef();
    const intl = useIntl();
    const stateAlternatives = getStateAlternatives(intl);
    const isLocalCountryAlternatives = getIsLocalCountryAlternatives(intl, countryName);
    const entityType = pepContext.state.legalEntityType || EntityType.PERSON;
    const nextPage = useCallback(() => {
        if (formRef.current && formRef.current.isValid) {
            next();
        }
    }, [formRef, next]);
    const updateIsLocalCountry = useCallback((alternative) => {
        pepContext.setState({ isLocalCountry: alternative.value });
        if (alternative.value === "other") {
            pepContext.setState({ country: undefined });
        }
        else {
            pepContext.setState({ country: countryCode });
        }
    }, [pepContext, countryCode]);
    const updateIsOngoing = useCallback((alternative) => {
        pepContext.setState({ isOngoing: alternative.value });
        if (alternative.value === PepStatus.ONGOING) {
            pepContext.setState({ ended: undefined });
        }
    }, [pepContext]);
    return (React.createElement("div", null,
        React.createElement(Form, { lysaFormRef: formRef, onSubmit: () => {
                nextPage();
            } },
            React.createElement(Card, null,
                React.createElement(RadioGroup, { alternatives: stateAlternatives, header: intl.formatMessage(isOngoingMessages.header, {
                        entityType,
                        name: pepContext.state.ownerName,
                        possessiveName: formatPossessive(pepContext.state.ownerName, intl.locale),
                        relation: pepContext.state.type === PepType.COLLEAGUE
                            ? pepContext.state.businessRelation
                            : pepContext.state.relationToPEP,
                        pepType: pepContext.state.type,
                    }), onChange: updateIsOngoing, value: stateAlternatives.find((alt) => alt.value === pepContext.state.isOngoing), validators: [
                        new RequiredValidator(intl.formatMessage(isOngoingMessages.required)),
                    ] }),
                pepContext.state.isOngoing &&
                    pepContext.state.isOngoing === PepStatus.ENDED ? (React.createElement(Datepicker, { label: intl.formatMessage(endedMessages.header), selected: pepContext.state.ended, onChange: (event) => {
                        pepContext.setState({ ended: event || undefined });
                    }, validators: [
                        new RequiredValidator(intl.formatMessage(endedMessages.required)),
                    ], showMonthYearPicker: true, dateFormat: "yyyy-MM", maxDate: new Date() })) : null),
            React.createElement(Card, null,
                React.createElement(RadioGroup, { alternatives: isLocalCountryAlternatives, header: intl.formatMessage(isLocalCountryMessages.header, {
                        possessiveName: formatPossessive(pepContext.state.ownerName, intl.locale),
                    }), onChange: updateIsLocalCountry, value: isLocalCountryAlternatives.find((alt) => alt.value === pepContext.state.isLocalCountry), validators: [
                        new RequiredValidator(intl.formatMessage(isLocalCountryMessages.required)),
                    ] }),
                pepContext.state.isLocalCountry &&
                    pepContext.state.isLocalCountry === "other" ? (React.createElement(CountrySelect, { label: intl.formatMessage(countrySelectionMessages.header, {
                        entityType,
                        name: pepContext.state.ownerName,
                        possessiveName: formatPossessive(pepContext.state.ownerName, intl.locale),
                        relation: pepContext.state.type === PepType.COLLEAGUE
                            ? pepContext.state.businessRelation
                            : pepContext.state.relationToPEP,
                        pepType: pepContext.state.type,
                    }), onChange: (event) => pepContext.setState({
                        country: event.value ? event.value : undefined,
                    }), validators: [
                        new RequiredValidator(intl.formatMessage(countrySelectionMessages.required)),
                    ], value: pepContext.state.country, omitList: [countryCode], language: language, placeholder: intl.formatMessage(countrySelectionMessages.placeholder) })) : null),
            React.createElement(Button, { label: React.createElement(FormattedMessage, { id: "pep.status.next" }), block: true, type: "submit" }))));
};
function getIsLocalCountryAlternatives(intl, countryName) {
    return [
        {
            text: intl.formatMessage(localCountryAltMessages.localCountry, {
                countryName,
            }),
            value: "local",
        },
        {
            text: intl.formatMessage(localCountryAltMessages.otherCountry),
            value: "other",
        },
    ];
}
function getStateAlternatives(intl) {
    return [
        {
            text: intl.formatMessage(stateAltMessages[PepStatus.ONGOING]),
            value: PepStatus.ONGOING,
        },
        {
            text: intl.formatMessage(stateAltMessages[PepStatus.ENDED]),
            value: PepStatus.ENDED,
        },
    ];
}
